import { StoreAction } from '../../decorators/store-action/store-action.decorator';
import { GenericStoreAction } from '../generic/generic-action';

@StoreAction("InstitutionalAccounts")
export class InstitutionalAccountsActions extends GenericStoreAction{
    constructor(type: string, payload?: any){
        super(type, payload);
    }
}